module.exports = __webpack_public_path__ + "static/img/12.6bac5c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting602/images/12.png
// module id = OjhV
// module chunks = 4